var _rect, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodsample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2408_6978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2408_6978)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2408_6978",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2408_6978",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEIUlEQVR4nO2dS4gcRRjHfxhNcLOhkxzEZNc8rkJOhiBEyUHQgzcPgp7VKDGHEFAiSO4eAoFchUAOCQgOxAcq4mPjPpCYxHN2wwZDgmAU0bCrRjtUrIFh6Nnt6a7p+rbr/4OC2aWn6+v+zVfVVf0CIYQQQgghhBBNsQF4E5gBfvdlGjgErG8sCnGfCeAykA8ol4DJ/xcVTWTGjyvI6JYFYMfIoxEcLiFDUhpkpm+nfwJsA7YDHUlpnt/6droT0eVB4JykNMvtFYRISgS+6RPS8ZkhKZE4WNAkuWZKUiKQAbMDjqg+KJCyDjhTsOwisDvGBqQiI5eU5mXMFQj4t+/va8CjBd/X0VcDmfEd8DgwX7IZUvM1wsy4AIz7Zdz0yJclp0mUKSPKjE011qtMMSSji6QEbqaG5SGNU+xkhsuGsxqn2JKhcUrAZqpOn3EywDRLcmcesxHJwB8KL9SUcimlc/TZCGWElPIGCZA1IKOqlE5BP9ZqsgZlVJEy0beMO0vZWrIIMoaV0i/kV1pKFlHGalI6/ojKlU8L4msdmQEZXdws8d1Vzq30ltdpGZkhGeO+3rIyLrbtsDczJGPTkDJ+8P1Ja8jWgAwX3yvAt77z/tNfjNe6i7azAXNT0xFkbAS+HtAcbSEBMsmwQyYZdsgkY21dN5VHLsn3GbkBCZJB/J0vGQZ2ei4Z6jPMoA7cEJJhCMkwhGQYQjIMIRmGkIw1cHLJUpnzcYbgeX831rz/bIrUMmMvcKdn3UvAkxghtcyYBG4V1HHLwvn01DLjAeCrFeqa8rc0RCE1GY7jJep8lwikKOMp4J8S9bpl9tMgqfUZ+HUtDlH/YuD6B5JiZjhOVYjD3Y01UlKV8cSQ1/X2PsZjHyMixWaqy1SNmNzFdsFJNTMczwSI7QABSTkzWGXMUba456oEIeXMcOwE/gsQo1vHLgLcEzGbcGY4jgWM9W1qTg98lriMup15f3EP4qzMOwZ2eB5ZRtHjZeuUX6oGsc3fgJK6DMdfAeN262psRNrWC59/Chj79SoBuF/esoEdn0fOjEEPYM6bHiC+aGDH5wYyo8tbAbfhaJUAThvY+bmBzOh9YECIFsOd3n2sSgAXDQjIDWRGLycCbMd7VSu/YUBCbkhGd4Bc5u08g8oVf0dvJax06HMRm6kidvU8fHmYctVPv1TmZ8kYyFb/Zp6yMj7236lFndRsY2YU8RzwBfB3Qfzuf58DzxKIDyWjNJuBp4GXgZf85+A/ptcS78DNsT3Q/L9kBOQjybDFnoKXnigzIvO+jqZs8TDwvTLDFm4y7GZgKTNrYJxhmomAmeLeODAWe4PawJjvU6p29H8AR2JvRFuPvs4PMU5Z9hcbPxI78BQGj6/6t89c8bdxLfnzz7M+m16I8NBKIYQQQgghhBCU4x4gXgsBkgqWMwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodsample);
export default __webpack_public_path__ + "static/media/bloodsample.62e42744aab4096daf5306d38aa66835.svg";
export { ForwardRef as ReactComponent };